import React, { FC, useState } from 'react'
import { RegionAutoSelectComponent } from 'Pages/landings/common/components/RegionAutoSelect'
import { LogoComponent } from 'Pages/landings/common/components/Logo'
import { MobileMenuComponent } from 'Pages/landings/common/components/Menu/mobileMenu'
import { useScroll } from 'Pages/landings/common/hooks/useScroll'
import { Region } from 'Pages/landings/common/types'
import './style.scss'

interface MenuItem {
	name: string
	link: string
}

interface ComponentProps {
	region?: Region
	setRegion?: (reg: Region) => void
	menuItems?: MenuItem[]
	hideRegionSelect?: boolean
}

export const MenuComponent: FC<ComponentProps> = ({
	setRegion,
	region,
	menuItems,
	hideRegionSelect,
}) => {
	const [showMenu, setShowMenu] = useState(false)
	const [showModal, setShowModal] = useState(false)
	const { scrollIntoBlock } = useScroll()

	const className = {
		menu: 'landing-menu',
		drawer: 'landing-menu-drawer',
		left: 'landing-menu_left',
		right: 'landing-menu_right',
		right_mobile: 'landing-menu_right-mobile',
		item: 'landing-menu_right_item',
		list_mobile: 'landing-menu_right-mobile_list',
		item_mobile: 'landing-menu_right-mobile_list_item',
	}

	const onClickItem = () => {
		setShowMenu(false)
	}

	const onToggleModal = () => {
		setShowModal((prevState) => !prevState)
	}

	const onScrollTo = (selector: string) => () => {
		scrollIntoBlock(selector)
		if (showMenu) setShowMenu(false)
	}

	const renderItemMenu = (isMobile: boolean) => {
		const itemClassName = isMobile ? className.item_mobile : className.item
		return (
			<div className={isMobile ? className.list_mobile : className.right}>
				{menuItems.map((item) => (
					<div key={item.link} className={itemClassName} onClick={onScrollTo(item.link)}>
						{item.name}
					</div>
				))}
				{!hideRegionSelect && (
					<RegionAutoSelectComponent
						className={itemClassName}
						setRegion={setRegion}
						region={region}
						isShowModal={showModal}
						setIsShowModal={onToggleModal}
					/>
				)}
			</div>
		)
	}

	return (
		<div className={className.menu}>
			<div className={className.left}>
				<LogoComponent />
			</div>

			{renderItemMenu(false)}

			<div className={className.right_mobile}>
				<img src="../img/landing/landing-menu.svg" alt="" onClick={() => setShowMenu(true)} />
				{showMenu && (
					<MobileMenuComponent onClose={onClickItem}>{renderItemMenu(true)}</MobileMenuComponent>
				)}
			</div>
		</div>
	)
}
